// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.system-info h2[data-v-4da1b73d] {
  font-weight: normal;
  font-size: 24px;
}
.team-member-img[data-v-4da1b73d] {
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.team-member-img img[data-v-4da1b73d] {
  max-height: 50px;
  max-width: 50px;
  border: 3px solid #d2d2d2;
  border-radius: 50%;
}
.team-member-img-green[data-v-4da1b73d] {
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.team-member-img-green img[data-v-4da1b73d] {
  max-height: 50px;
  max-width: 50px;
  border: 3px solid #00c01a;
  border-radius: 50%;
}
.team-member-img-red[data-v-4da1b73d] {
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.team-member-img-red img[data-v-4da1b73d] {
  max-height: 50px;
  max-width: 50px;
  border: 3px solid #ff0000;
  border-radius: 50%;
}
.team-member-img-amber[data-v-4da1b73d] {
  margin-top: 5px;
  display: inline-block;
  margin-bottom: 5px;
}
.team-member-img-amber img[data-v-4da1b73d] {
  max-height: 50px;
  max-width: 50px;
  border: 3px solid #ffbb00;
  border-radius: 50%;
}
.team-member-img.b-red img[data-v-4da1b73d] {
  border-color: #cf1e60;
}
.team-member-img.b-pink img[data-v-4da1b73d] {
  border-color: #ff8a65;
}
.gridView[data-v-4da1b73d] {
  border: 0px;
}
.incident-manager-list[data-v-4da1b73d] .v-table thead > tr > th:nth-child(1) {
  width: 12px;
  padding-right: 24px !important;
}
.incident-manager-list[data-v-4da1b73d] .v-table thead > tr > th:nth-child(2) {
  min-width: 80px;
}
.incident-manager-list[data-v-4da1b73d] .v-table thead > tr > th:nth-child(3) {
  min-width: 250px;
}
.incident-manager-list[data-v-4da1b73d] .v-table thead > tr > th:nth-child(4) {
  min-width: 150px;
}
.incident-manager-list[data-v-4da1b73d] .v-table tbody > tr.selected-manager {
  background: #e8e8e8;
}
.incident-manager-list[data-v-4da1b73d] .v-table tbody > tr.selected-manager td {
  font-weight: 600;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
